<template>
  <ListeConfiguration />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ListeConfiguration from "@/components/GesCom/Configuration/ListeConfiguration.vue";

export default defineComponent({
  name: "ListeConfigurationPage",
  components: {
    ListeConfiguration,
  },
});
</script>
